import {
	AfterContentChecked,
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	QueryList,
	SimpleChanges,
	ViewChild,
	ViewChildren,
} from "@angular/core";
import {Project, ProjectName} from "../../../core/models/Project";
import {EmployeeFullName} from "../../../core/models/EmployeeFullName";
import {EmployeeService} from "../../../core/services/services/employee.service";
import {Client} from "../../../core/config/Client";
import {CustomizingService} from "../../../core/services/services/customizing.service";
import {TranslatableComponent} from "../../../core/models/TranslatableComponent";
import {TranslateService, TranslatePipe} from "@ngx-translate/core";
import Config from "../../../core/config/Config";
import {ProjectStatus} from "../../../core/models/Enums/ProjectStatus";
import {DropDownChoice} from "../../../feature/employee-operations/abstract-employee-details.component";
import {AuthenticationService} from "../../../core/services/services/authentication.service";
import {NgModel, ReactiveFormsModule, FormsModule} from "@angular/forms";
import {DeliveryType} from "../../../core/models/Enums/DeliveryType";
import {ProjectCritically} from "../../../core/models/Enums/ProjectCritically";
import {MatSelect} from "@angular/material/select";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ProjectService} from "../../../core/services/services/project.service";
import {DivisionService} from "../../../core/services/services/division.service";
import {forkJoin, from, Subject, Subscription} from "rxjs";
import {debounceTime, map, switchMap} from "rxjs/operators";
import {BusinessUnitService} from "../../../core/services/services/businessUnit.service";
import MarketUnit from "../../../core/config/MarketUnit";
import {AddAggregatedProjectDialogComponent} from "../../dialogs/add-aggregated-project-dialog/add-aggregated-project-dialog.component";
import {ConfirmationDialogComponent} from "../../dialogs/confirmation-dialog/confirmation-dialog.component";
import {AlertEnum} from "../../../core/models/Enums/AlertEnum";
import {MessageService} from "../../../core/services/services/message.service";
import {
	MatTableDataSource,
	MatTable,
	MatColumnDef,
	MatHeaderCellDef,
	MatHeaderCell,
	MatCellDef,
	MatCell,
	MatHeaderRowDef,
	MatHeaderRow,
	MatRowDef,
	MatRow,
} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {ProjectTimeSliceForm} from "../../../core/models/ProjectTimeSlice";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {DataService} from "../../../core/services/services/data.service";
import {MatFormField, MatLabel, MatHint, MatError, MatSuffix} from "@angular/material/form-field";
import {MatTooltip} from "@angular/material/tooltip";
import {MatInput} from "@angular/material/input";
import {NgStyle, DatePipe} from "@angular/common";
import {MatAutocompleteTrigger, MatOption} from "@angular/material/autocomplete";
import {ClientAutocompleteComponent} from "../../autocomplete/components/client-autocomplete";
import {EmployeeAutocompleteComponent} from "../../autocomplete/components/employee-autocomplete.component";
import {MatDatepickerInput, MatDatepickerToggle, MatDatepicker} from "@angular/material/datepicker";
import {NewsNotificationComponent} from "../../news-notification/news-notification.component";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {RouterLink} from "@angular/router";
import {AutosizeDirective} from "../../autosize/autosize.directive";
import {SelectSearchComponent} from "../../select-search/select-search.component";
import {MatCheckbox} from "@angular/material/checkbox";
import {PspListTransformPipe} from "../../pipes/pipes/psp-list-transform.pipe";
import {Chart, PieController, ArcElement, Tooltip, Legend} from "chart.js";

Chart.register(PieController, ArcElement, Tooltip, Legend);

@Component({
	selector: "app-project-data-input",
	templateUrl: "./project-data-input.component.html",
	styleUrls: ["./project-data-input.component.scss"],
	imports: [
		MatFormField,
		MatTooltip,
		MatLabel,
		MatInput,
		ReactiveFormsModule,
		FormsModule,
		MatHint,
		NgStyle,
		MatAutocompleteTrigger,
		ClientAutocompleteComponent,
		EmployeeAutocompleteComponent,
		MatSelect,
		MatOption,
		MatError,
		MatDatepickerInput,
		MatDatepickerToggle,
		MatSuffix,
		MatDatepicker,
		NewsNotificationComponent,
		MatIcon,
		MatTable,
		MatSort,
		MatColumnDef,
		MatHeaderCellDef,
		MatHeaderCell,
		MatCellDef,
		MatCell,
		MatIconButton,
		MatSortHeader,
		RouterLink,
		MatHeaderRowDef,
		MatHeaderRow,
		MatRowDef,
		MatRow,
		AutosizeDirective,
		SelectSearchComponent,
		MatCheckbox,
		DatePipe,
		TranslatePipe,
		PspListTransformPipe,
	],
})
export class ProjectDataInputComponent extends TranslatableComponent implements OnInit, OnChanges, AfterContentChecked, OnDestroy {
	@Output() isDataEdited = new EventEmitter<string>();
	@Output() statusChanged = new EventEmitter<string>();
	@Output() projectUpdated = new EventEmitter<Project>();
	@Input()
	project: Project;
	@Input()
	isEditMode: boolean;
	@Input()
	isAddMode: boolean;
	@ViewChildren(NgModel) fields: QueryList<NgModel>;
	@ViewChild("projectCategory") category: MatSelect;
	@Input() projectProbabilitiesDataSource!: MatTableDataSource<ProjectTimeSliceForm, MatPaginator>;
	@ViewChild(MatSort) sort: MatSort;
	@ViewChild("projectScopeEmpty") projectScopeEmpty!: ElementRef<HTMLInputElement>;
	@ViewChild("projectScopeFilled") projectScopeFilled!: ElementRef<HTMLInputElement>;

	projectEditable: boolean;
	currentClient: Client;

	strategicObjective: DropDownChoice<string>[] = null;
	businessTopics: DropDownChoice<string>[] = null;
	branches: DropDownChoice<string>[] = this.getEnums("branches");
	marketUnit: DropDownChoice<string>[] = this.getEnums("businessUnit");
	businessUnit: DropDownChoice<string>[];
	msgUnit: DropDownChoice<string>[] = this.getEnums("msgUnit");
	deliveryType = Object.keys(DeliveryType);
	projectCritically = Object.keys(ProjectCritically);
	projectStatus: string[] = Object.keys(ProjectStatus).slice(1);
	divisions: DropDownChoice<string>[] = null;
	projectCategories: DropDownChoice<string>[] = this.getEnums("projectCategory");
	billingType: DropDownChoice<string>[];
	isMsgRomaniaRelevant: boolean;
	projectLeaderSelected: boolean = true;
	divisionManagerSelected: boolean = true;
	initialBusinessTopics: DropDownChoice<string>[];
	aggregatedProjectsDataSource = new MatTableDataSource<Project>();
	aggregatedProjectsDisplayedColumns: string[] = [
		"delete",
		"projectName",
		"projectLeader",
		"psp",
		"startDate",
		"endDate",
	];
	showFinishedAggregatedProjects = true;
	aggregatedProjectsUnfiltered;
	isAggregationAvailable: boolean;
	isShowWorkPackageEnabled: boolean = false;
	chartCreated = false;
	calculatedProjectVolumeSum: number = 0;

	private projectLeaderSearchSubject = new Subject<string>();
	private divisionManagerSearchSubject = new Subject<string>();
	private chartRecreateTimeoutId?: ReturnType<typeof setTimeout>;
	private msgUnitSubscription?: Subscription;

	constructor(
		private employeeService: EmployeeService,
		private loginService: AuthenticationService,
		private customizing: CustomizingService,
		public dialog: MatDialog,
		translate: TranslateService,
		private authenticationService: AuthenticationService,
		private projectService: ProjectService,
		private businessUnitService: BusinessUnitService,
		private divisionService: DivisionService,
		private cdref: ChangeDetectorRef,
		private _messageService: MessageService,
		public _dataService: DataService,
	) {
		super(translate, "ProjectDataComponent");
		this.aggregatedProjectsDataSource = new MatTableDataSource<Project>();
	}

	async ngOnInit() {
		this.isAggregationAvailable = await this.customizing.isAggregationAvailable();
		this.isShowWorkPackageEnabled = await this.customizing.isShowWorkPackageEnabled();

		this.currentClient = await this.customizing.getCurrentClient();

		this.billingType = this.employeeService.fetchAttributeOption("billingType", false, this.currentClient);
		this.strategicObjective = this.employeeService.fetchAttributeOption(
			"strategicObjective",
			false,
			this.currentClient,
		);
		this.businessUnit = await this.fetchValidBusinessUnitOptions();

		while (!this.project.businessUnit) {
			await new Promise((resolve) => setTimeout(resolve, 100));
		}

		await this.customizing.isProjectEditable(this.project.businessUnit).then((editable) => {
			this.projectEditable = editable;
		});

		const applicationUser = await this.authenticationService.getApplicationUser();
		if (applicationUser.employee?.businessUnit && !this.project.businessUnit) {
			this.project.businessUnit = applicationUser.employee.businessUnit;
		}
		this.businessUnit = this.withProjectBusinessUnitOption(this.businessUnit, this.project.businessUnit);

		this.updateDivisionsAndBusinessTopics();
		this.isMsgRomaniaRelevant = this.project.msgRomaniaRelevant;

		this.getProfitCenter();

		this.projectLeaderSearchSubject
			.pipe(
				debounceTime(500),
				switchMap((searchTerm) => this.autoSelectProjectLeaderByNameSearch(searchTerm)),
			)
			.subscribe();

		this.divisionManagerSearchSubject
			.pipe(
				debounceTime(500),
				switchMap((searchTerm) => this.autoSelectDivisionManagerByNameSearch(searchTerm)),
			)
			.subscribe();
		this.updateMsgUnitFromBusinessUnit();
	}

	/**
	 * Die Auswahl der Business Units wird durch eine Änderung der Msg Unit eingeschränkt
	 * (updateBusinessUnitsBasedOnMsgUnit). Wird das Projekt zurückgesetzt, muss auch die ungefilterte Auswahl wieder her.
	 */
	private async resetBusinessUnitOptions() {
		const requestedProject = this.project;
		const options = this.withProjectBusinessUnitOption(
			await this.fetchValidBusinessUnitOptions(),
			requestedProject?.businessUnit,
		);
		if (this.project === requestedProject) {
			this.businessUnit = options;
		}
	}

	private async fetchValidBusinessUnitOptions(): Promise<DropDownChoice<string>[]> {
		const validBUs = await this.employeeService.getBusinessUnits(false);
		return (await this.projectService.fetchBusinessUnitOptions(true)).filter((businessUnit) =>
			validBUs.includes(businessUnit.value),
		); // Note that this might remove the MISSING_VALUE-entry for non-admins
	}

	/**
	 * Die Business Unit des Projekts muss auswählbar bleiben, auch wenn der User für sie nicht berechtigt ist.
	 */
	private withProjectBusinessUnitOption(
		options: DropDownChoice<string>[],
		projectBusinessUnit: string,
	): DropDownChoice<string>[] {
		if (!projectBusinessUnit || options.some((option) => option.value === projectBusinessUnit)) {
			return options;
		}
		return options.concat({
			value: projectBusinessUnit,
			viewValue: MarketUnit.MarketUnit[projectBusinessUnit],
		} as DropDownChoice<string>);
	}

	/**
	 * Die Msg Unit ist nicht am Projekt persistiert, sondern ergibt sich aus der Business Unit. Da das Projekt
	 * mehrfach durch eine Server-/Backup-Kopie ersetzt wird (Navigation, Abbrechen, Nachladen), muss sie jedes Mal neu
	 * ermittelt werden. Antworten, die zu einem inzwischen ersetzten Projekt oder einer geänderten Business Unit
	 * gehören, werden verworfen.
	 */
	private updateMsgUnitFromBusinessUnit() {
		this.msgUnitSubscription?.unsubscribe();
		const requestedProject = this.project;
		const requestedBusinessUnit = requestedProject?.businessUnit;
		if (!requestedBusinessUnit) {
			return;
		}
		this.msgUnitSubscription = this.businessUnitService
			.getMsgUnitByBusinessUnit(requestedBusinessUnit)
			.subscribe((msgUnit) => {
				if (this.project === requestedProject && this.project.businessUnit === requestedBusinessUnit) {
					this.project.msgUnit = msgUnit;
				}
			});
	}

	ngAfterContentChecked(): void {
		this.cdref.detectChanges();
		this.aggregatedProjectsDataSource.sort = this.sort;
		if (
			this.project.projectScopePd !== undefined &&
			this.calculatedProjectVolumeSum > 0 &&
			!this.chartCreated &&
			this.project.projectScopePd !== null
		) {
			if (Chart.getChart("projectScopePieChart")) {
				Chart.getChart("projectScopePieChart").destroy();
			}
			new Chart("projectScopePieChart", {
				type: "pie",
				data: {
					labels: [
						this.calculatedProjectVolumeSum.toFixed(0) +
							"PT des geplanten\nGesamtaufwands von\n" +
							this.project.projectScopePd.toFixed(0) +
							"PT sind eingeplant.\nDas entspricht " +
							((this.calculatedProjectVolumeSum / this.project.projectScopePd) * 100).toFixed(0) +
							"%",
						(this.project.projectScopePd - this.calculatedProjectVolumeSum).toFixed(0) +
							"PT des geplanten\nGesamtaufwands von\n" +
							this.project.projectScopePd.toFixed(0) +
							"PT sind noch\nnicht eingeplant.\nDas entspricht " +
							(100 - (this.calculatedProjectVolumeSum / this.project.projectScopePd) * 100).toFixed(0) +
							"%",
					],
					datasets: [
						{
							data:
								this.calculatedProjectVolumeSum <= this.project.projectScopePd
									? [
											this.calculatedProjectVolumeSum / this.project.projectScopePd,
											1 - this.calculatedProjectVolumeSum / this.project.projectScopePd,
										]
									: [1, 0],
							backgroundColor: ["#FF6384", "#36A2EB"],
						},
					],
				},
				options: {
					maintainAspectRatio: false,
					plugins: {
						legend: {
							display: false,
						},
						tooltip: {
							enabled: false,
						},
					},
				},
			});
			this.chartCreated = true;
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.project) {
			this.fields?.forEach((model) => model.control.markAsUntouched());
			this.updateDivisionsAndBusinessTopics();
			this.updateMsgUnitFromBusinessUnit();
			if (!changes.project.firstChange) {
				this.resetBusinessUnitOptions();
			}
		}

		if (typeof this.project.projectVolume === "string") {
			if (this.project.projectVolume.endsWith("EUR")) {
				this.project.projectVolume = this.project.projectVolume.replace(" EUR", "").replace(".", "").replace(",", ".");
				this.project.projectVolume = Number(this.project.projectVolume).toString();
			}
			if (this.project.projectVolume.endsWith("-")) {
				this.project.projectVolume = this.project.projectVolume.substring(0, this.project.projectVolume.length - 1);
			}
		}

		if (this.project && !this.project.strategicObjective) {
			this.project.strategicObjective = "OTHER";
		} else if (this.project && this.project.strategicObjective && this.strategicObjective) {
			let soToAssign = "MISSING_VALUE";
			this.strategicObjective.forEach((so) => {
				if (so.value === this.project.strategicObjective) {
					soToAssign = so.value;
				}
			});
			this.project.strategicObjective = soToAssign;
		}
	}

	onSearchSelectFiltered(options: DropDownChoice<string>[]) {
		this.businessTopics = options;
	}

	updateResortManager(employeeFullName: EmployeeFullName) {
		this.project.resortManager = employeeFullName;
		this.project.resortManager._links = {self: {href: Config.services.employees.baseUrl + employeeFullName.id}};
	}

	updateProjectLeader(employeeFullName: EmployeeFullName) {
		this.projectLeaderSelected = true;
		this.project.projectLeader = employeeFullName;
		this.project.projectLeader._links = {self: {href: Config.services.employees.baseUrl + employeeFullName.id}};
	}

	updateDivisionManager(employeeFullName: EmployeeFullName) {
		this.divisionManagerSelected = true;
		this.project.divisionManager = employeeFullName;
		this.project.divisionManager._links = {self: {href: Config.services.employees.baseUrl + employeeFullName.id}};
	}

	updateResponsibleAL(employeeFullName: EmployeeFullName) {
		this.project.responsibleAL = employeeFullName;
		this.project.responsibleAL._links = {self: {href: Config.services.employees.baseUrl + employeeFullName.id}};
	}

	updateDeliveryResponsibleMsgRo(employeeFullName: EmployeeFullName) {
		this.project.deliveryResponsibleMsgRo = employeeFullName;
		this.project.deliveryResponsibleMsgRo._links = {
			self: {href: Config.services.employees.baseUrl + employeeFullName.id},
		};
	}

	updateDivisionsAndBusinessTopics() {
		this.updateDivisions();
		this.updateBusinessTopics();
	}

	updateDivisions() {
		this.divisionService.getDivisionOptionsByBusinessUnit([this.project.businessUnit]).then((divisionOptions) => {
			divisionOptions.unshift({
				value: Config.services.missingValueBackend,
				viewValue: Config.services.missingValue,
			});
			this.divisions = divisionOptions;

			// check if current division exists in options
			if (!this.divisions.some((option) => option.value === this.project.division)) {
				if (this.project.division === undefined) {
					this.inputModelChanged(this.project.division);
				} else {
					this.divisions.unshift({value: this.project.division, viewValue: this.project.division});
				}
			}
		});
	}

	updateBusinessTopics() {
		this.projectService.getBusinessTopics([this.project.businessUnit], true, false).then((businessTopicOptions) => {
			this.businessTopics = businessTopicOptions.sort((a, b) => a.viewValue.localeCompare(b.viewValue));
			if (
				this.businessTopics.some((option) => option.value === this.project.businessTopic) &&
				this.project.businessTopic === undefined
			) {
				this.project.businessTopic = "N/A";
				this.inputModelChanged(this.project.businessTopic);
			}
			this.initialBusinessTopics = [...this.businessTopics];
		});
	}

	getProfitCenter() {
		this.project.id &&
			this.projectService.getProfitCenter(this.project.id).subscribe((result) => {
				this.project.profitCenter = result;
			});
	}

	async updateBusinessUnitsBasedOnMsgUnit(selectedMsgUnit) {
		if (!selectedMsgUnit) {
			this.businessUnitService.getAllBusinessUnits();
		} else {
			const requestedProject = this.project;
			this.businessUnitService.getBusinessUnitByMsgUnit(selectedMsgUnit).subscribe((bus) => {
				// Antwort verwerfen, wenn das Projekt inzwischen ersetzt (z.B. Abbrechen) oder die Msg Unit erneut geändert wurde
				if (this.project !== requestedProject || this.project.msgUnit !== selectedMsgUnit) {
					return;
				}
				this.businessUnit = bus
					.map(
						(businessUnit) =>
							({
								value: businessUnit.businessUnit,
								viewValue: MarketUnit.MarketUnit[businessUnit.businessUnit],
							}) as DropDownChoice<string>,
					)
					.filter((entry) => entry.viewValue !== undefined)
					.sort((a, b) => a.viewValue.localeCompare(b.viewValue));
			});
		}
	}

	isCurrentClientGBP(): boolean {
		return this.currentClient === Client.GBP;
	}

	isCurrentClientMSA(): boolean {
		return this.currentClient === Client.MSG_SERVICES;
	}

	isCurrentClientMSAOrZM() {
		return this.currentClient === Client.MSG_SERVICES || this.currentClient === Client.ZM;
	}

	isCurrentClientMSAOrZMOrGBPOrCONPLANOrGBG() {
		return (
			this.currentClient === Client.MSG_SERVICES ||
			this.currentClient === Client.ZM ||
			this.currentClient === Client.GBP ||
			this.currentClient === Client.CONPLAN
		);
	}

	isCurrentClientZT() {
		return this.currentClient === Client.ZT;
	}

	isUrl(url: string): boolean {
		try {
			return !!new URL(url);
		} catch {
			return false;
		}
	}

	defaultDisabledCondition(): boolean {
		return !this.isEditMode || !this.projectEditable;
	}

	chartInputModelChanged(newVal: any) {
		this.inputModelChanged(newVal);
		setTimeout(() => {
			if (this.project.projectScopePd) {
				this.projectScopeFilled?.nativeElement.focus();
			} else {
				this.projectScopeEmpty?.nativeElement.focus();
			}
		});
		if (newVal) {
			clearTimeout(this.chartRecreateTimeoutId);
			this.chartRecreateTimeoutId = setTimeout(() => {
				this.chartCreated = false;
			}, 300);
		}
	}

	ngOnDestroy(): void {
		clearTimeout(this.chartRecreateTimeoutId);
		this.msgUnitSubscription?.unsubscribe();
	}

	inputModelChanged(newVal: any) {
		if (newVal) {
			this.isDataEdited.emit(newVal);
		}
	}

	onStartDateChange() {
		if (!this.project.endDate || Date.parse(this.project.startDate) > Date.parse(this.project.endDate)) {
			this.project.endDate = this.project.startDate;
		}
	}

	onToDateChange() {
		if (Date.parse(this.project.startDate) > Date.parse(this.project.endDate)) {
			this.project.startDate = this.project.endDate;
		}
	}

	projectLeaderChanged(newVal: any) {
		this.projectLeaderSelected = false;
		this.projectLeaderSearchSubject.next(newVal);
		this.inputModelChanged(newVal);

		if (this.project.projectLeader && (this.project.projectLeader.id || this.project.projectLeader._links)) {
			this.projectLeaderSelected = true;
		}
	}

	divisionManagerChanged(newVal: any) {
		this.divisionManagerSelected = false;
		this.divisionManagerSearchSubject.next(newVal);
		this.inputModelChanged(newVal);

		if (this.project.divisionManager && (this.project.divisionManager.id || this.project.divisionManager._links)) {
			this.divisionManagerSelected = true;
		}
	}

	autoSelectProjectLeaderByNameSearch(newVal: string) {
		return from(this.employeeService.fetchEmployeeFullNameByNameSearch(newVal, false, false, true)).pipe(
			map((employees) => {
				employees.map((employee) => {
					if (employee.firstName + " " + employee.lastName === newVal) {
						this.updateProjectLeader(employee);
					}
				});
			}),
		);
	}

	autoSelectDivisionManagerByNameSearch(newVal: string) {
		return from(
			this.employeeService.fetchEmployeeFullNameByNameSearch(newVal, !this.isCurrentClientZT(), false, false),
		).pipe(
			map((employees) => {
				employees.map((employee) => {
					if (employee.firstName + " " + employee.lastName === newVal) {
						this.updateDivisionManager(employee);
					}
				});
			}),
		);
	}

	projectStatusChanged(newVal: any) {
		if (newVal) {
			this.statusChanged.emit(newVal);
		}
	}

	openInfoDialog() {
		this.dialog.open(InformationSecurityPopup);
	}

	// Getting the Enum array from the config file
	private getEnums(keyWord: string): DropDownChoice<string>[] {
		let options = Object.keys(Config.services.employees[keyWord])
			.sort()
			.map((i) => ({value: i, viewValue: Config.services.employees[keyWord][i]}));
		if (keyWord === "businessUnit") {
			options.unshift({
				value: Config.services.missingValueBackend,
				viewValue: Config.services.missingValue,
			});
		}
		return options;
	}

	openAddAggregatedProjectDialog() {
		const dialogRef = this.dialog.open(AddAggregatedProjectDialogComponent, {
			disableClose: false,
			data: {
				id: this.project?.id,
				isAddMode: this.isAddMode,
				existingChildren: [...this.aggregatedProjectsDataSource.data],
			},
			width: "500px",
			position: {
				left: "195px",
				top: "100px",
			},
		});

		if (this.isAddMode) {
			dialogRef.afterClosed().subscribe((newProjects: ProjectName[]) => {
				if (!newProjects?.length) {
					return;
				}

				// Die Autocomplete liefert nur ProjectName (ohne Projektleitung). Die Tabelle zeigt aber
				// dieselben Spalten wie im Bearbeiten-Modus, deshalb die vollen Projekte nachladen.
				forkJoin(newProjects.map((project) => this.projectService.getProjectData(project.sharePointId))).subscribe({
					next: (fullProjects) => {
						this.aggregatedProjectsDataSource.data = [...this.aggregatedProjectsDataSource.data, ...fullProjects];
						this.aggregatedProjectsUnfiltered = this.aggregatedProjectsDataSource.data;
					},
					error: () => {
						this._messageService.add(this._lang("notification.fetch-project-failed"), AlertEnum.DANGER);
					},
				});
			});
		}
	}

	async deleteAggregatedProjectClicked(project) {
		if (this.isAddMode) {
			this.aggregatedProjectsDataSource.data = this.aggregatedProjectsDataSource.data.filter((p) => p.id !== project.id);
			this.aggregatedProjectsUnfiltered = this.aggregatedProjectsDataSource.data;
			return;
		}

		try {
			const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
				disableClose: false,
				data: "mep.components.general.notification.delete-aggregated-project",
			});
			dialogRef.afterClosed().subscribe(async (value) => {
				if (value) {
					await this.projectService.removeAggregate(this.project.id, project.id);
					this._messageService.add(
						this.translate.instant("mep.components.project-data.delete-aggregated-project-success"),
						AlertEnum.SUCCESS,
					);
					window.location.reload();
				}
			});
		} catch (e) {
			this._messageService.add(
				this.translate.instant("mep.components.project-data.delete-aggregated-project-error"),
				AlertEnum.DANGER,
			);
		}
	}

	aggregationInit(selected: Project[]) {
		let aggregatedProject: Project = null;
		this.projectService.getProjectData(selected[0].sharePointId).subscribe((project) => {
			aggregatedProject = Object.assign({}, project);
			aggregatedProject.id = null;
			aggregatedProject.sharePointId = null;

			let title = document.getElementById("detail-title");
			title.innerText = this.translate.instant("mep.components.project-data.agg-title");

			this.projectService.getProjectProbabilities(aggregatedProject, false).then((probabilities) => {
				this.projectProbabilitiesDataSource.data = probabilities.map((slice) => new ProjectTimeSliceForm(slice));
			});
			aggregatedProject.projectName =
				project.projectName + this.translate.instant("mep.components.project-data.agg-name-ending");

			let allPsps = "";
			selected.forEach((selectedProject, index) => {
				if (index + 1 === selected.length) {
					allPsps = allPsps.concat(selectedProject.psp);
				} else {
					allPsps = allPsps.concat(selectedProject.psp + ", ");
				}
			});
			aggregatedProject.psp = allPsps;

			this.project = aggregatedProject;
			this.aggregatedProjectsDataSource.data = selected;
			this.aggregatedProjectsUnfiltered = selected;
			this.projectUpdated.emit(this.project);
			this.cdref.detectChanges();

			setTimeout(() => this.markFieldsAsTouchedAndValid(), 0);
		});
	}

	async fetchAggregatedProjects(selectedProject: Project) {
		const isAggregationAvailable = await this.customizing.isAggregationAvailable();

		if (isAggregationAvailable) {
			this.projectService.getChildProjects(selectedProject.id).subscribe(
				(projectsSet) => {
					const projectsArray = Array.from(projectsSet);
					this.aggregatedProjectsDataSource.data = projectsArray;
					this.aggregatedProjectsUnfiltered = projectsArray;
				},
				() => {
					this._messageService.add(this._lang("notification.fetch-project-failed"), AlertEnum.DANGER);
				},
			);
		}
	}

	finishedCheckboxChange() {
		this.showFinishedAggregatedProjects = !this.showFinishedAggregatedProjects;
		if (this.showFinishedAggregatedProjects) {
			this.aggregatedProjectsDataSource.data = this.aggregatedProjectsUnfiltered;
		} else {
			let filtered: Project[] = [];
			this.aggregatedProjectsDataSource.data.forEach((project) => {
				if (project.status !== "COMPLETED") {
					filtered.push(project);
				}
			});
			this.aggregatedProjectsDataSource.data = filtered;
		}
	}

	private markFieldsAsTouchedAndValid(): void {
		this.fields?.forEach((field) => {
			field.control.markAsTouched();
			field.control.updateValueAndValidity();
		});
	}

	generateChartTooltip(): string {
		return this.translate.instant("mep.components.project-data-input.project-scope-chart-tooltip", {
			calculatedVolume: this.calculatedProjectVolumeSum.toFixed(0),
			totalVolume: this.project.projectScopePd.toFixed(0),
			percentage: ((this.calculatedProjectVolumeSum / this.project.projectScopePd) * 100).toFixed(0),
			remainingVolume: (this.project.projectScopePd - this.calculatedProjectVolumeSum).toFixed(0),
		});
	}
}

@Component({
	selector: "information-security-popup",
	templateUrl: "information-security-popup.html",
	imports: [MatIcon, TranslatePipe],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class InformationSecurityPopup {
	constructor(public dialogRef: MatDialogRef<InformationSecurityPopup>) {}

	close() {
		this.dialogRef.close();
	}
}
